import { RegisteredUser } from "../../proto/Global_pb";
import { UserUpdateStatusResponse } from "../../proto/UserUpdateStatus_pb";
import { Fetching } from "../../constants/globals";

export const GET_USER = "GET_USER";
export const GOTO_USER = "GOTO_USER";
export const ADD_USERS = "ADD_USERS";
export const ADD_USER = "ADD_USER";
export const ADD_USER_BLOCKED = "ADD_USER_BLOCKED";
export const ADD_USER_CONTACTS = "ADD_USER_CONTACTS";
export const REMOVE_USER_BLOCKED = "REMOVE_USER_BLOCKED";
export const SET_USER_STATUS = "SET_USER_STATUS";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER_CONTACT = "DELETE_USER_CONTACT";
export const SET_USER_STORAGE_SETTINGS = "SET_USER_STORAGE_SETTINGS";

export type UsersType = {
  [userId in RegisteredUser.AsObject["id"]]: Fetching<RegisteredUser.AsObject>;
};

export type UserStorageSettings = {
  saved_file: number;
  auto_download: boolean;
  auto_play_gif: boolean;
  auto_play_video: boolean;
};

export type UserContactsType = Array<keyof UsersType>;
export type UserBlockedType = Array<keyof UsersType>;
export type UserStatusType = {
  [userId in RegisteredUser.AsObject["id"]]: UserUpdateStatusResponse.AsObject["status"];
};

export type UserStateType = {
  users: UsersType;
  userContacts: UserContactsType;
  userBlocked: UserBlockedType;
  userStatus: UserStatusType;
  userAvatar?: RegisteredUser.AsObject["avatar"];
  userStorageSettings: UserStorageSettings;
  loading: "idle" | "loading" | "resolve" | "reject";
};
export type AddUsersActionType = {
  type: typeof ADD_USERS;
  payload: Array<RegisteredUser.AsObject>;
};
export type GetUserActionType = {
  type: typeof GET_USER;
  payload: { userId: RegisteredUser.AsObject["id"] };
};
export type UpdateUserActionType = {
  type: typeof UPDATE_USER;
  payload: {
    userId: keyof UsersType;
    values: Partial<RegisteredUser.AsObject>;
  };
};
export type AddUserContactsActionType = {
  type: typeof ADD_USER_CONTACTS;
  payload: Array<keyof UsersType>;
};
export type DeleteUserContactActionType = {
  type: typeof DELETE_USER_CONTACT;
  payload: RegisteredUser.AsObject["phone"];
};
export type AddUserBlockedActionType = {
  type: typeof ADD_USER_BLOCKED;
  payload: Array<keyof UsersType>;
};
export type RemoveUserBlockedActionType = {
  type: typeof REMOVE_USER_BLOCKED;
  payload: keyof UsersType;
};
export type SetUserStatusActionType = {
  type: typeof SET_USER_STATUS;
  payload: UserStatusType;
};

export type SetUserStorageSettingsType = {
  type: typeof SET_USER_STORAGE_SETTINGS;
  payload: UserStorageSettings;
};
export type GoToUserActionType = {
  type: typeof GOTO_USER;
  payload: { userId: RegisteredUser.AsObject["id"] };
};
